import { useContext } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Typography } from 'mobily-ui-library/lib';
import BlueNetwork from '../../../assets/BlueNetwork.svg';
import NoNetwork from '../../../assets/NoNetwork.svg';
import { GlobalContext } from '../../../context/GlobalContext';
import './HomeCheck.scss';

interface Props {
  rtl: boolean;
  results: Array<string>;
}

function HomeCheck(props: Props) {
  const { t } = useTranslation();
  const { rtl, results } = props;
  const { dispatch }: any = useContext(GlobalContext)

  const handleClick = (value: string | any) => {
    window.open(value, '_blank');
  }

  const handleNotify = () => {
    dispatch({ type: 'SET_NOTIFY_ME', payload: true })
  }

  const floatDirection = rtl ? 'HC-right' : 'HC-left';

  return (
    <div className={`HomeCheck__container ${floatDirection}`}>
      {results.length > 0 && results.map((result: any) => {
        const coverageList = result.coverageList[0]
        const additionalInfo = result.coverageList[0].additionalInfoList[0];
        const noCoverage = coverageList.coveredLabelEn.toLowerCase().replace(/\s/g, '') === 'nocoverage';

        return (
          <div className='HC__Section' key={result.subSectionId} style={{ float: rtl ? 'right' : 'left' }}>
            <Typography rtl={props.rtl} className='HC__options--title'>{rtl ? result.subSectionLabelAr : result.subSectionLabelEn}</Typography>

            <div className='HC__NetworkType'>
              <Typography className='HC__Network'>
                <img src={noCoverage ? NoNetwork : BlueNetwork} alt='network' />
                <span>{rtl ? coverageList.coverageTypeLabelAr : coverageList.coverageTypeLabelEn}</span>
              </Typography>
              <Typography className={noCoverage ? 'HC__CoverageType HC__Nocoverage' : 'HC__CoverageType'}>{rtl ? coverageList.coveredLabelAr : coverageList.coveredLabelEn}</Typography>
            </div>

            {noCoverage && (
              <Typography className='HC__NoCoverage-Text' rtl={rtl}>
                {rtl ? coverageList.notCoveredMsgAr : coverageList.notCoveredMsgEn}
              </Typography>
            )}

            <Button
              rtl={props.rtl}
              onClick={(noCoverage && coverageList.coverageType === "FIBER") ? handleNotify : () => handleClick(additionalInfo.value)}
              className={(noCoverage && coverageList.coverageType === "AIR_FIBER") ? "HC_Null" : "HC__buttonNames"}
              primary={coverageList.coverageType === 'FIBER' ? true : false}
              variant={'default'}
            >
              {(noCoverage && coverageList.coverageType === "FIBER") ? t("Notify_Button") : !noCoverage && (rtl ? additionalInfo.label.ar : additionalInfo.label.en)}
            </Button>
          </div>
        )
      })}
    </div>
  )
}

export default HomeCheck;